import { QueryBusinessDataResult } from "@/api/business_gmv/interface";
import { GoalTypeEnums } from "@/api/home/interface";
import { isNullOrEmpty, plus2 } from "@/common/util/helpers";
import moment from "moment";

/** 支付金额目标进度/推广花费目标进度 */
export const goalTypeList = [
  {
    title: "支付金额",
    type: GoalTypeEnums.GMV,
    tooltip:
      "统计周期内，授权店铺的在「所选类目」X「所选品牌」的支付金额加和，多个店铺的支付金额不去重，未剔除售后订单",
  },
  {
    title: "推广花费",
    type: GoalTypeEnums.COST,
    tooltip:
      "授权店铺的推广花费总和，即全站推广、商品推广、标准推广、明星店铺、直播推广、品牌直推等所有推广产品线的现金、虚拟金、津贴和红包总和",
  },
];

/** 获取和 */
export const getSum = (list: number[] = []) => {
  return list.reduce(
    (total, item) => plus2(total, isNullOrEmpty(item) ? 0 : item),
    0
  );
};

/**
 * 数组中的每个数字保留2位小数, 2位小数后面多余的顺延到下一个数字, 直到最后一个数字
 * @example [1.111, 2.222, 3.333] => [1.11, 2.223, 3.333] => [1.11, 2.22, 3.335]
 */
export const getMonthList = (list: number[]) => {
  let currentFix = 0;

  return list.map((item) => {
    const plusPreFix = plus2(item, currentFix);
    const fixed = Number(item.toFixed(2));
    currentFix = plus2(plusPreFix, -fixed);

    return fixed;
  });
};

/**
 * 获取一个数字列表每一项的百分比
 * @example [1, 2, 3] => [16.67, 33.33, 50]
 */
export const getMonthPercentList = (list: number[] = [], total: number) => {
  return total
    ? list.map((item) => Number(((item / total) * 100).toFixed(2)))
    : [];
};

export const getStartEndTime = (timeRange: number) => {
  return {
    startTime: moment().add(-timeRange, "d"),
    endTime: moment(),
  };
};

export const BACKEND_FORMAT = "YYYY-MM-DD";
export const FRONTEND_FORMAT = "YYYY/MM/DD";
export const CAN_SELECT_TIME_LIST = [1, 7, 30, 90];

export interface CardItem {
  /** 标题 */
  title?: string;
  /** 在接口数据中的key */
  key?: keyof QueryBusinessDataResult;
  /** 提示 */
  notice?: string;
  /** 变化率的key */
  changeKey?: keyof Pick<
    QueryBusinessDataResult,
    | "gmvChangeRatio"
    | "payUvChangeRatio"
    | "payCountChangeRatio"
    | "unitPriceChange"
    | "custAveraPriceChange"
  >;
  /** 是否是价格 */
  isPrice?: boolean;
  /** 标题的宽度 */
  width?: number;
}

/** 交易数据的卡片 */
export const cardList: CardItem[] = [
  {
    title: "支付金额",
    key: "allGmv",
    notice:
      "统计周期内，授权店铺的在「所选类目」X「所选品牌」的支付金额加和，多个店铺的支付金额不去重，未剔除售后订单",
    changeKey: "gmvChangeRatio",
    isPrice: true,
    width: 70,
  },
  {
    title: "支付买家数",
    key: "allPayUv",
    notice:
      "统计周期内，授权店铺的在「所选类目」X「所选品牌」的支付买家数加和，多个店铺的支付买家数不去重，未剔除售后订单",
    changeKey: "payUvChangeRatio",
    width: 60,
  },
  {
    title: "支付订单数",
    key: "allPayCount",
    notice:
      "统计周期内，授权店铺的在「所选类目」X「所选品牌」的订单数，多个店铺的支付订单不去重",
    changeKey: "payCountChangeRatio",
    width: 60,
  },
  {
    title: "支付客单价",
    key: "custAveraPrice",
    notice:
      "统计周期内，授权店铺在「所选类目」X「所选品牌」的支付金额总数/支付买家数（跨店铺不去重），即平均每个支付买家的支付金额",
    changeKey: "custAveraPriceChange",
    isPrice: true,
    width: 82,
  },
  {
    title: "支付笔单价",
    key: "unitPrice",
    notice:
      "统计周期内，授权店铺在「所选类目」X「所选品牌」的支付金额总数/支付订单数（跨店铺不去重），即平均每笔成交的支付金额",
    changeKey: "unitPriceChange",
    isPrice: true,
    width: 82,
  },
];
